import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import classes from "../../styles/CheckinFormStyle";
import Switch from "@mui/material/Switch";
import {
  useCheckinFormStatusMutation,
  useDeleteCheckInFormMutation,
} from "../../services/admin";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

export default function PositionedMenu({ isActivated, id }: any) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [checked, setChecked] = React.useState(isActivated);

  const open = Boolean(anchorEl);

  const [checkinFormStatus] =
    useCheckinFormStatusMutation();
  const [deleteCheckInForm] = useDeleteCheckInFormMutation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Activate or De-Activate Status
  const isActivatedHandler = (e: any) => {
    setAnchorEl(null);
    const payload = { isActivated: e.target.checked };
    checkinFormStatus({ id, payload })
      .unwrap()
      .then((res: any) => toast.success(res?.message))
      .catch(() => toast.error("Something went wrong"));
    setChecked(!checked);
  };

  // Delete CheckIn Form
  const deleteHandler = () => {
    setAnchorEl(null);
    deleteCheckInForm(id)
      .unwrap()
      .then(() => {
        toast.success("Deleted Successfully");
      })
      .catch(() => {
        toast.error("Something went wrong ");
      });
  };



  return (
    <div>
      <Button
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MoreVertIcon fontSize="large" sx={{ color: "#333333" }} />
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{ width: "20.3rem" }}
      >
        {/* <MenuItem sx={classes.menuItems} onClick={handleClose}>
          View
        </MenuItem> */}
        <Link to={`/edit-form/${id}`}>
          <MenuItem sx={classes.menuItems} onClick={handleClose}>
            Edit
          </MenuItem>
        </Link>
        {!isActivated && (
        <MenuItem sx={classes.menuItems} onClick={deleteHandler}>
          Delete
        </MenuItem>
        )}
        <MenuItem sx={classes.menuItems}>
          Activate <Switch onChange={isActivatedHandler} checked={isActivated} />
        </MenuItem>
      </Menu>
    </div>
  );
}
